import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { useDispatch, useSelector } from "react-redux";
import { /* clearGetEffectiveOrNot,*/ getEffectiveOrNot } from "../../../store/actions/deadlines/accountant";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "./style.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  Table } from "antd";
import { DATETIME_FORMATZ_FOR_API } from "../../../constants/constants";
import moment from "moment";
import { useIntl } from "react-intl";
import SolicitModal from "./solicitModal";
import { useLocation, useNavigate } from "react-router-dom";
import EmptyState from "../../vapor/emptyState";
import { columnDef } from "./columnsDef";
import FilterHeader from "./FilterHeader";
import { Button } from "@ts-digital/vrc";
import DialogMerge from "./dialogMerge";
import { FEATURE_TOGGLE_ADD_NEW_DEADLINES } from "../../../config";
import { getDeadlines } from "../../../store/actions/deadlines/company";
import { getFirstDateOfMonth, getLastDateOfMonth } from "../../../libs/deadlinesUtils";

const DeadlinesTable = ({customersView, setCustomersView,  balanceDetailDialog,
  setBalanceDetailDialog}) => {
  const intl = useIntl();
  
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableScrollRef = useRef();  
  const companiesArray = useSelector(state => state.company?.companies);
  const deadlines = useSelector(state => state.main.myType === "STUDIO" ? state.deadlinesAccountant : state.deadlinesCompany);
  const isArchivingDeadlines = useSelector(state => state.deadlinesCompany.isArchivingDeadlines);
  const main = useSelector(state => state.main);
  const myType = main.myType;
  const companySelected = main.companySelected;

  const useMergeState = initialState => {
    const [state, setState] = useState(initialState);
    const setMergedState = newState =>
      setState(prevState => Object.assign(
        {}, prevState, newState
      ));
    return [state, setMergedState];
  };
  // necessario per filtrare la data
  const [filterDate, setFilterDate] = useMergeState({
    check: false,
    date: null
  });
  
  const [dataSet, setDataSet] = useState([]);
  // Flag che apre o chiude la dialog per il ragggruppamento scadenze
  const [dialogMerge, setDialogMerge] = useState(false);
  // Check per attivazione del pulsante del pagamento multiplo con tspay
  const [multiplePay, setMultiplePay] = useState(false);
  // Check se si tratta di selezione per raggruppa o compensa
  const [mergeType, setMergeType] = useState(null);
  // Righe selezionate per operazioni come il raggruppamento scadenze
  const [selectedRows, setSelectedRows] = useState([]);
  const [isReset, setIsReset] = useState(true);
  const [solicitDeadlineId, setSolicitDeadlineId] = useState(null);
  const [openSolicitDialog, setOpenSolicitDialog] = useState(false);
  const [solicitRagioneSociale, setSolicitRagioneSociale] = useState(null);
  // hasMoreItems è necessario per conoscere se ci sono altre scadenze, serve anche a gestire l'infinite scroller
  const [hasMoreItems, setHasMoreItems] = useState(false);
  const [queryParameters, setQueryParameters] = useState(null);
  
  const onChangeFilter = useCallback(async(
    isRefresh = false, name, value
  ) => {         
    setIsReset(isRefresh);            
    let newQueryParameters = { ...queryParameters };
    if (typeof name === "object"){
      name.map((el, key) => newQueryParameters[el] = value[key]);
    } else {
      newQueryParameters[name] = value;    
    }     
             
    await setQueryParameters(newQueryParameters);
  }, [queryParameters?.archived, 
    queryParameters?.confirmed,
    queryParameters?.counterpartDescription,
    queryParameters?.fromDate,
    queryParameters?.paymentMode,
    queryParameters?.paymentStep,
    queryParameters?.paymentType,
    queryParameters?.sameAttachmentsAs,
    queryParameters?.scope,
    queryParameters?.toDate,  
    queryParameters?.specificDate,  
    queryParameters?.sameAttachmentsAs,    
    queryParameters?.scopes,
    queryParameters?.status,  
    queryParameters?.expired]);

  const columns = columnDef(
    intl, myType, setSolicitDeadlineId, setSolicitRagioneSociale, 
    onChangeFilter, hasMoreItems, queryParameters, customersView, 
    dispatch, companiesArray, navigate, setOpenSolicitDialog
  ).filter(item => !item.hidden);

  const initial = {
    key: "initial",
    itemId: "initial",
    date: "initial",
    description: "initial",
    amount: "initial",
    paymentMode: "initial",
    management: "initial",
    status: "initial",
    isRead: "initial",
    actions: "initial"
  };  

  const createDataSet = (
    res, links, oldDataSet
  ) => {
    
    if (!res) return undefined;
    let finalDataSet = [];
    const newSetArrayDeadlines = [];
    res.map(el => {                    
      newSetArrayDeadlines.push({
        key: el.id,
        date:  el.date,
        itemId: companiesArray.find(co => co.uuid === el.itemId)?.ragioneSociale,
        description: el?.description?.title + (el?.description?.details ? " " + el?.description?.details : ""),
        counterpart: el?.counterpart,          
        amount: el.totalAmount,
        paymentMode: "",
        payment: el?.payment,
        scope: el?.scope,
        management: "",
        status: el.status,
        isRead: "",
        actions: null,
        notesCount: el.notesCount,
        bankTransactionCount: el.bankTransactionCount,
        type: el.type
      });
    });
       
    finalDataSet = oldDataSet.concat(newSetArrayDeadlines);

    if (!links){    
      const totalAmountTable = finalDataSet.length > 1 ?
        finalDataSet?.reduce((a, b) => {
          return (typeof a === "object" ? a?.amount : a) + b?.amount;
        }) :
        finalDataSet.length === 1 ?
          dataSet?.[0]?.amount :
          0;

      finalDataSet.length > 0 &&
      finalDataSet.push({
        key: "-1",
        itemId: "final",
        date: "final",
        description: `${intl.formatMessage({
          id: "deadlines.table.total"
        })} ${finalDataSet.length} ${intl.formatMessage({
          id: finalDataSet.length > 1 ? "deadlines.table.deadlines" : "deadlines.table.deadline"
        })}`,
        amount: totalAmountTable,
        paymentMode: "final",
        management: "final",
        status: "final",
        isRead: "final",
        actions: "final"
      });
    }   

    setDataSet(finalDataSet);
    setHasMoreItems(typeof links === "string"); 
    if (isReset && document.querySelector(".tableAreaScrollable")) {
      document.querySelector(".tableAreaScrollable").scrollTop = 0;
    }
    return undefined;
  };

  /** Funzione che chiama l'api di caricamento scadenze */
  const getDeadlinesFunc = useCallback(() => {     
        
    const oldDataSet = isReset ? [] : [...dataSet];  
    
    if (myType === "STUDIO"){
      dispatch(getEffectiveOrNot(
        customersView ? false : true,
        deadlines.effectiveOrNot.next && !isReset
          ? deadlines.effectiveOrNot.next.href
          : undefined,
        isReset,
        queryParameters,
        true
      )).then((res) => {             
        createDataSet(
          res?._embedded?.deadlines, res?._links?.next?.href, oldDataSet
        );
        setIsReset(false);
      });
    } else {    
      
      dispatch(getDeadlines(
        true,
        isReset,
        queryParameters.specificDate ? moment(queryParameters.specificDate).format("YYYY-MM-DD") : queryParameters.fromDate ? moment(queryParameters.fromDate).format("YYYY-MM-DD") : null,
        queryParameters.specificDate ? moment(queryParameters.specificDate).format("YYYY-MM-DD") : queryParameters.toDate ? moment(queryParameters.toDate).format("YYYY-MM-DD") : null,        
        queryParameters.sameAttachmentsAs,
        queryParameters.counterpartDescription,
        10,
        0,
        queryParameters.scopes,
        queryParameters.status,
        queryParameters.archived,
        queryParameters.confirmed,
        queryParameters.paymentMode,
        queryParameters.paymentType,
        deadlines?._links?.next?.href,
        queryParameters?.expired
      )).then((res) => {             
        createDataSet(
          res?._embedded?.deadlines, res?._links?.next?.href, oldDataSet
        );
        setIsReset(false);
      });
    }
    
  }, [isReset, dataSet, queryParameters?.archived, 
    queryParameters?.confirmed,
    queryParameters?.counterpartDescription,
    queryParameters?.fromDate,
    queryParameters?.paymentMode,
    queryParameters?.paymentStep,
    queryParameters?.paymentType,
    queryParameters?.sameAttachmentsAs,
    queryParameters?.scope,
    queryParameters?.toDate,  
    queryParameters?.specificDate,  
    queryParameters?.sameAttachmentsAs,    
    queryParameters?.scopes,
    queryParameters?.status,  
    queryParameters?.expired]);
  
  useEffect(() => {
    /** Tolgo lo scroll del body quando si apre la modale */
    if (dialogMerge) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
  }, [dialogMerge]);
  
  // Al cambio selezione delle righe, controllo se abilitare o meno il pagamento multiplo con tspay
  useEffect(() => {
    let activate = true;
    let totalAmount = 0;
    
    if (selectedRows.length === 0) {
      setMultiplePay(null);
      return;
    }
    selectedRows.map(row => {
      if (row.amount >= 0) {
        activate = false;
      } else {
        totalAmount += row.amount;
      }
      return null;
    });
    if (!activate) {
      setMultiplePay(null);
      
    } else {
      setMultiplePay(totalAmount);
    }

    let checkCompensation = false;
    let checkValue = null;
    selectedRows.map(row => {
      
      if (checkValue === null) {
        checkValue = row.amount;
      } else {
        if (
          (checkValue >= 0 && row.amount < 0) ||
          (checkValue < 0 && row.amount >= 0)
        ) {
          checkCompensation = true;
        }
      }
      return null;
    });
    setMergeType(checkCompensation ? "compensation" : "group");

  }, [selectedRows]);
  
  useEffect(() => {    
         
    if (location.state?.scrollTop)  setIsReset(false);       
    
    createDataSet(
      myType==="STUDIO" ? deadlines?.effectiveOrNot?.deadlines : deadlines.subjective, 
      myType==="STUDIO" ? deadlines?.effectiveOrNot?.next?.href : deadlines._links?.next?.href, []
    );        
    const selectedMonth = customersView && localStorage.getItem("monthFilterDeadlines") ? localStorage.getItem("monthFilterDeadlines") : new Date().getMonth(); 
    const selectedYear = customersView && localStorage.getItem("yearFilterDeadlines")  ? localStorage.getItem("yearFilterDeadlines") : new Date().getFullYear(); 
    // const daysinMonth = moment(`${selectedYear}-${parseInt(selectedMonth) + 1}`, "YYYY-MM").daysInMonth();
    setQueryParameters(deadlines.filtersActive ? deadlines.filtersActive : {
      confirmed: true,
      fromDate: moment(getFirstDateOfMonth(selectedMonth ? parseInt(selectedMonth)  : new Date().getMonth(), selectedYear ? parseInt(selectedYear) : new Date().getFullYear())).format(DATETIME_FORMATZ_FOR_API),
      toDate: moment(getLastDateOfMonth(selectedMonth ? parseInt(selectedMonth) : 11, selectedYear ? parseInt(selectedYear) : new Date().getFullYear())).format(DATETIME_FORMATZ_FOR_API),
      archived: false
    });
    
  }, [/* deadlines?.effectiveOrNot?.deadlines,*/ customersView]);
  
  useEffect(() => {         
    if (location.state?.scrollTop || !queryParameters) return undefined;   
    getDeadlinesFunc();    
    
    return undefined;
    /* return () => {
      // dispatch(clearGetEffectiveOrNot());
    };*/
  }, [queryParameters?.archived, 
    queryParameters?.confirmed,
    queryParameters?.counterpartDescription,
    queryParameters?.fromDate,
    queryParameters?.paymentMode,
    queryParameters?.paymentStep,
    queryParameters?.paymentType,
    queryParameters?.sameAttachmentsAs,
    queryParameters?.scope,
    queryParameters?.toDate,  
    queryParameters?.specificDate,  
    queryParameters?.sameAttachmentsAs,    
    queryParameters?.scopes,
    queryParameters?.status,  
    queryParameters?.expired,
    queryParameters?.itemId
  ]);

  useEffect(() => {
    if (!tableScrollRef.current) return undefined;    
    let ps = new Scrollbar(tableScrollRef.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [tableScrollRef?.current]);
  
  useLayoutEffect(() => {      
    if (location.state?.scrollTop && location.state?.scrollParentTop){  
      // serve quando torno indietro
      navigate(location.pathname, {});       
      document.querySelector(".tableAreaScrollable").scrollTop = location.state.scrollTop;
      document.querySelector(".dbx-main-page-container").scrollTop = location.state.scrollParentTop;
      return;
    }    
  }, [dataSet]);
  
  const onSelectChange = (newSelectedRowKeys, elements) => {     
    
    setSelectedRows(elements.filter(el => el.key !== "initial" && el.key !=="-1"));
  };

  /** Funzione per controllare che una scadenza derivi da una fattura o meno */
  const renderSpinner = (
    <div
      style={{ position: "fixed", top: "154px", 
        backgroundColor: "rgba(256,256,256, 0.7)", 
        width: "100%",
        height: "calc(100% - 154px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center", fontSize: "32px", color: "#0090d1" }}
      key={Math.random()}
    >
      <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
    </div>
  );

  const objCompanySelected = companiesArray
    ? companiesArray.find(el => {
      return el.codiceFiscale === companySelected;
    })
    : null;

  const classifierCompanySelected = objCompanySelected
    ? objCompanySelected.classifier
    : null;
    
  return (
    <div>
      <div className="deadlinesAddDeadlineRow">
        <FilterHeader
          queryParameters={queryParameters}                 
          onChangeFilter={onChangeFilter}
          customersView={customersView}
          selectedRows={selectedRows}
          mergeType={mergeType}            
          setCustomersView={setCustomersView}
          classifierCompanySelected={classifierCompanySelected}
          setSelectedRows={(rows, currentCompany) => {            
            setSelectedRows(rows || []);
          }}
          setDialogMerge={setDialogMerge}
          filterDate={filterDate}
          setFilterDate={value => setFilterDate(value)}
          multiplePay={multiplePay}
          balanceDetailDialog={balanceDetailDialog}
          setBalanceDetailDialog={setBalanceDetailDialog}
        />
        {FEATURE_TOGGLE_ADD_NEW_DEADLINES === "true" &&
          !customersView &&
          !queryParameters?.counterpartDescription &&
          !queryParameters?.sameAttachmentsAs && (
          <Button
            style={{
              marginLeft: 32,
              marginTop: 20,
              width: "20%",
              display: "none"
            }}
            onClick={() => navigate("/creascadenza")}
          >
            {intl.formatMessage({
              id: "deadlines.addDeadline"
            })}
          </Button>
        )}
      </div>
    
      <div className="tableAreaScrollable" ref={tableScrollRef}>
        <InfiniteScroll
          initialLoad={false}
          pageStart={1}    
          loadMore={() => {                           
            if (            
              (typeof deadlines?.effectiveOrNot?.next?.href
             !== "undefined" || typeof deadlines?._links?.next?.href!== "undefined") &&
            !deadlines?.effectiveOrNot?.status?.started &&
            !deadlines?.isGettingDeadlines && 
            !isArchivingDeadlines            
            ) {      
              // setIsReset(false);
              getDeadlinesFunc();                        
            }
          }}
          threshold={10}
          hasMore={hasMoreItems}
          loader={(deadlines?.effectiveOrNot?.status?.started || deadlines?.isGettingDeadlines) && renderSpinner}
          useWindow={false}    
          getScrollParent={() => 
            tableScrollRef.current
          // tableScrollRef.current?.children[0]?.children[0]?.children[0]?.children[0]?.children[0]?.children[0]?.children[1]
          }             
        >        
          <Table pagination={false}  
            style={{padding: "16px", tableLayout: "fixed"}}
            rowKey={record => record.key}
            
            rowSelection={      
              
              (!!queryParameters?.counterpartDescription || !!queryParameters?.sameAttachmentsAs) ? {                
                // selectedRowKeys: selectedRows.find(el => el.key);
                onChange: onSelectChange,
                getCheckboxProps: (record) => {                                  
                  return {
                    name: record.key,
                    disabled: (record.key === "initial" || record.key === "-1" || !["customer", "supplier"].includes(record?.type) || record?.payment?.step === "suspended" ||
                    record?.payment?.step === "collected" || record?.payment?.step === "paid" || !["credit", "debt"].includes(record?.scope) || !record?.status?.confirmed)
                  };                            
                }
              } : null
            }
            className="deadlinesTable"
            // scroll={{ y: "calc(100vh - 154px - 77px)", scrollToFirstRowOnChange: true }}
            columns={columns} dataSource={[initial, ...dataSet]} 
            rowClassName={(record, index) => {
              if ((record?.payment?.status === "due" ||
              record?.payment?.status === "suspended" ||
              record?.status?.rejected) &&
            new Date(record?.date) < new Date().setHours(
              0, 0, 0, 0
            )) {
              
                return "customBordered red";
              }                                
              return "customBordered";
            }}
          />      
          {
            dataSet.length < 2 && (!deadlines?.effectiveOrNot?.status?.started && !deadlines?.isGettingDeadlines) &&
          <EmptyState withIcon={true} title="Nessuna scadenza" description={"Per il filtro selezionato"} />
          }  
        </InfiniteScroll>
      
        <SolicitModal solicitDeadlineId={solicitDeadlineId} openSolicitDialog={openSolicitDialog} setOpenSolicitDialog={setOpenSolicitDialog} ragSocCompany={solicitRagioneSociale} />
      </div>
      {dialogMerge && (
        <DialogMerge                 
          visible={dialogMerge}
          selectedRows={selectedRows}          
          mergeType={mergeType}
          onClose={resetParams => {
            setDialogMerge(false);
            if (resetParams) {
              setSelectedRows([]);              
              let tmpQP = { ...queryParameters };
              delete tmpQP["sameAttachmentsAs"];
              delete tmpQP["counterpartDescription"];
              
              setQueryParameters(tmpQP);
            }
          }}
        />
      )}
    </div>
  );
};

export default DeadlinesTable;